// "Today" design language, shared by the dashboard and the app shell (TopBarV2). Fonts load in public/index.html.
export const SERIF = "'Instrument Serif', Georgia, 'Times New Roman', serif";
export const SANS = "'Instrument Sans', 'Helvetica Neue', Helvetica, sans-serif";
export const MONO = "'JetBrains Mono', ui-monospace, monospace";

export const TODAY_TOKENS = {
  light: {
    bg: '#F2EFE7', surface: '#FFFFFF', surfaceAlt: '#FBFAF6',
    ink: '#15171C', body: '#3A3E47', muted: '#5B5F68',
    line: '#DDD8CC', lineSoft: '#ECE8DE', lineStrong: '#CFC9BB',
    navy: '#1C2B5A', rust: '#B93A12', amber: '#B7791F', amberText: '#8A5A00', green: '#2D6A4F',
    accent: '#E4572E', panel: '#15171C', panelText: '#F2EFE7', panelMuted: '#B4B7BF', panelLine: '#2E323B',
  },
  dark: {
    bg: '#121317', surface: '#1B1D22', surfaceAlt: '#17191D',
    ink: '#F2EFE7', body: '#C9CCD3', muted: '#9A9DA6',
    line: '#2E323B', lineSoft: '#262930', lineStrong: '#3A3E47',
    navy: '#8FA3E0', rust: '#F0714A', amber: '#D69E2E', amberText: '#E0B45C', green: '#52B788',
    accent: '#E4572E', panel: '#0B0C0F', panelText: '#F2EFE7', panelMuted: '#B4B7BF', panelLine: '#2E323B',
  },
};

export const todayTokens = (isDarkMode) => (isDarkMode ? TODAY_TOKENS.dark : TODAY_TOKENS.light);
